import React, { useEffect, useState } from 'react';
import { Itheme } from '../../../entities/Theme'
import { SketchPicker } from 'react-color';
import ReactToolTip from 'react-tooltip'

import primaryColorImg from '../../../assets/images/theme/PRIMARY-COLORS.png'
import primaryFontImg from '../../../assets/images/theme/PRIMARY-FONT.png'
import secondaryColorImg from '../../../assets/images/theme/SECONDARY-COLORS.png'
import secondaryFontImg from '../../../assets/images/theme/SECONDARY-FONT.png'

interface IThemFormProps {
    data: Itheme;
    onChange?: (prop: string, value: any) => void;
    errors?: any;
}

const Theme: React.FC<IThemFormProps> = ({ data, onChange,errors }) => {
    const [backgroundSP1, setBackgroundSP1] = useState(data.primaryColor);
    const [backgroundSP2, setBackgroundSP2] = useState(data.secondaryColor);
    const [backgroundSP3, setBackgroundSP3] = useState(data.iconColor);
    const [backgroundSP4, setBackgroundSP4] = useState(data.primaryFontColor);
    const [backgroundSP5, setBackgroundSP5] = useState(data.secondaryFontColor);

    const handleChangeComplete = (color: any) => {
        setBackgroundSP1(color.hex)
    };
    const handleChangeCompleteSP2 = (color: any) => {
        setBackgroundSP2(color.hex)
    };
    const handleChangeCompleteSP3 = (color: any) => {
        setBackgroundSP3(color.hex)
    };
    const handleChangeCompleteSP4 = (color: any) => {
        setBackgroundSP4(color.hex)
    };
    const handleChangeCompleteSP5 = (color: any) => {
        setBackgroundSP5(color.hex)
    };
    useEffect(() => {
        setBackgroundSP1(data.primaryColor)
        setBackgroundSP2(data.secondaryColor)
        setBackgroundSP3(data.iconColor)
        setBackgroundSP4(data.primaryFontColor)
        setBackgroundSP5(data.secondaryFontColor)
    })
    return (
        <div className=" justify-center  max-w-4xl flex-row md:flex lg:ml-72 mb-3">
            <div className="w-full flex justify-center md:justify-start  md:w-1/4">
                <p className="text-lg font-bold text-customBlue">Theme Options</p>
            </div>
            <div className="ml-3 md:w-3/4 mt-6 w-full">
                <div className="flex flex-col md:flex-row md:mb-4">
                    <ReactToolTip
                        id="primaryColor"
                    >
                        <img src={primaryColorImg} alt="" width="300px" />
                    </ReactToolTip>
                    <div id="primarycolor" className="flex flex-row pb-3 md:w-1/4" data-tip data-for="primaryColor">
                        <SketchPicker
                            className={` ${errors["primaryColor"] === 1 ? "custom-picker-error": ""}`}
                            color={backgroundSP1}
                            onChangeComplete={handleChangeComplete}
                            onChange={(value) => onChange?.("primaryColor", value.hex)}
                        />

                        <div className="absolute -mt-1 ml-1 bg-white">
                            <p className="custom-fixed-label   mr-1">Primary Color</p>
                        </div>
                        <p className="text-red-500 my-auto ml-1 mr-5">*</p>

                    </div>
                    <ReactToolTip
                        id="secondaryColorImg"
                    >
                        <img src={secondaryColorImg} alt="" width="300px" />
                    </ReactToolTip>
                    <div id="secondarycolor" className="flex flex-row pb-3 md:w-1/4" data-tip data-for="secondaryColorImg">
                        <SketchPicker
                            className={` ${errors["secondaryColor"] === 1 ? "custom-picker-error": ""}`}
                            color={backgroundSP2}
                            onChangeComplete={handleChangeCompleteSP2}
                            onChange={(value) => onChange?.("secondaryColor", value.hex)}
                        />
                        <div className="absolute -mt-1 ml-1 bg-white">
                            <p className="custom-fixed-label   mr-1">Secondary Color</p>
                        </div>
                        <p className="text-red-500 my-auto ml-1 mr-5">*</p>
                    </div>
                    <div id="iconcolor" className="flex flex-row pb-3 md:w-1/4">
                        <SketchPicker
                            className={` ${errors["iconColor"] === 1 ? "custom-picker-error": ""}`}
                            color={backgroundSP3}
                            onChangeComplete={handleChangeCompleteSP3}
                            onChange={(value) => onChange?.("iconColor", value.hex)}
                        />
                        <div className="absolute -mt-1 ml-1 bg-white">
                            <p className="custom-fixed-label   mr-1">Icon Color</p>
                        </div>
                        <p className="text-red-500 my-auto ml-1 mr-5">*</p>
                    </div>
                    <ReactToolTip
                        id="primaryFontImg"
                    >
                        <img src={primaryFontImg} alt="" width="300px" />
                    </ReactToolTip>
                    <div id="primaryfontcolor" className="flex flex-row pb-3 md:w-1/4" data-tip data-for="primaryFontImg">
                        <SketchPicker
                            className={` ${errors["primaryFontColor"] === 1 ? "custom-picker-error": ""}`}
                            color={backgroundSP4}
                            onChangeComplete={handleChangeCompleteSP4}
                            onChange={(value) => onChange?.("primaryFontColor", value.hex)}
                        />
                        <div className="absolute -mt-1 ml-1 bg-white">
                            <p className="custom-fixed-label   mr-1">Primary Font Color</p>
                        </div>
                        <p className="text-red-500 my-auto ml-1 mr-5">*</p>
                    </div>
                    <ReactToolTip
                        id="secondaryFontImg"
                    >
                        <img src={secondaryFontImg} alt="" width="300px" />
                    </ReactToolTip>
                    <div id="secondaryfontcolor" className="flex flex-row pb-3 md:w-1/4" data-tip data-for="secondaryFontImg">
                        <SketchPicker
                            className={` ${errors["secondaryFontColor"] === 1 ? "custom-picker-error": ""}`}
                            color={backgroundSP5}
                            onChangeComplete={handleChangeCompleteSP5}
                            onChange={(value) => onChange?.("secondaryFontColor", value.hex)}
                        />
                        <div className="absolute -mt-1 ml-1 bg-white">
                            <p className="custom-fixed-label   mr-1">Secondary Font Color</p>
                        </div>
                        <p className="text-red-500 my-auto ml-1 mr-5">*</p>
                    </div>
                </div>
                <div id="primaryfont" className="flex flex-row pb-3 md:w-1/2">
                    <select name="" id=""
                            required={errors["primaryFont"] === 1 ? true:false}
                        value={data.primaryFont}
                        className={`w-full rounded ${errors["primaryFont"] === 1 ? "custom-input-sm-successware-error": "custom-input-sm-successware"}`}
                        onChange={(value) => onChange?.("primaryFont", value.target.value)}
                    >
                        <option className="ml-3" value="">Select Primary Font</option>
                        <option className="ml-3" value="Arial">Arial</option>
                        <option className="ml-3" value="Verdana">Verdana</option>
                        <option className="ml-3" value="Helvetica">Helvetica</option>
                        <option className="ml-3" value="Tahoma">Tahoma</option>
                        <option className="ml-3" value="Trebuchet MS">Trebuchet MS</option>
                        <option className="ml-3" value="Times New Roman">Times New Roman</option>
                        <option className="ml-3" value="Georgia">Georgia</option>
                        <option className="ml-3" value="Courier New">Courier New</option>
                        <option className="ml-3" value="Brush Script MT">Brush Script MT</option>
                    </select>
                    <div className="absolute -mt-1 ml-1 bg-white">
                        <p className="custom-fixed-label   mr-1">Primary Font</p>
                    </div>
                    <p className="text-red-500 my-auto ml-1 mr-5">*</p>
                </div>
            </div>
        </div>
    )
}

export default Theme;